module.exports = __webpack_public_path__ + "img/h06-min.b08b0563.png";